function drawBackground(parent, background) {
    const colors = {
        "White": "#FFFFFF",
        "Gray": "#F0F0F0",
        "Cream": "#F8F2EC",
        "Pink": "#F8ECEC",
        "Blue": "#ECF1F8",
        "Black": "#000000"
    }
    parent.querySelector(".viewer-illustration").style.backgroundColor = colors[background];
}

function drawIllustration(parent, selector, length) {
    let el = parent.querySelector(selector);
    if (!el) return;
    let MAX_HEIGHT = 600;
    let MAX_LENGTH = 60;
    let INCH = 2.54;
    let lengthValue = parseFloat(length.replace(",", "."));
    let match = length.match(/([a-z]+)/i);
    let unit = match ? match[1].toLowerCase() : "cm";
    if (!isNaN(lengthValue) && ["in", "inch", "inches"].includes(unit)) lengthValue *= INCH;
    if (isNaN(lengthValue) || lengthValue < 10 || lengthValue > 60) lengthValue = 48;
    let height = `${100.0 * lengthValue / 60.0}%`;
    let top = `${100.0 * (60.0 - lengthValue) / 120.0}%`;
    el.style.height = height;
    el.style.top = top;
}

function renderBirthPoster(el) {
    const props = Object.fromEntries(JSON.parse(el.dataset.properties || '[]'));
    let birth_info = [];
    for (let field of ["Length", "Weight", "City", "Date", "Time"]) {
        if (field in props && props[field].length > 0) birth_info.push(props[field]);
        el.querySelector(".viewer-caption .info").textContent = birth_info.join(" · ");
    }
    drawBackground(el, props.Background);
    drawIllustration(el, ".viewer-motif", props.Length);
}

function renderSiblingPoster(el) {
    const props = Object.fromEntries(JSON.parse(el.dataset.properties || '[]'));
    // Child 1
    let birth_info = [];
    for (let field of ["Length #1", "Weight #1", "City #1", "Date #1", "Time #1"]) {
        if (field in props && props[field].length > 0) birth_info.push(props[field]);
        el.querySelector(".viewer-caption .info-1").textContent = birth_info.join(" · ");
    }
    // Child 2
    birth_info = [];
    for (let field of ["Length #2", "Weight #2", "City #2", "Date #2", "Time #2"]) {
        if (field in props && props[field].length > 0) birth_info.push(props[field]);
        el.querySelector(".viewer-caption .info-2").textContent = birth_info.join(" · ");
    }    
    drawBackground(el, props.Background);
    drawIllustration(el, ".viewer-motif-right", props["Length #1"]);
    drawIllustration(el, ".viewer-motif-left", props["Length #2"]);
}

function renderCartItem(el) {
    const product_title = el.dataset.productTitle;
    if (product_title === "Birth poster - single") renderBirthPoster(el);
    if (product_title === "Birth poster - duo") renderSiblingPoster(el);
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.viewer').forEach(renderCartItem);
});